export default {
    name: "Crossing moving average",
    data: {
        "id": "fc917982-1862-4970-8366-6ec20ae4eb32",
        "title": "Crossing movin average",
        "type": "Composite",
        "config": {
            "operator": "Filter",
            "combine_on": "exact_match",
            "left": {
                "id": "ae68a0b8-7bfa-480e-b902-58355e551b4c",
                "title": "Below one",
                "type": "Composite",
                "config": {
                    "operator": "Filter",
                    "combine_on": "exact_match",
                    "left": {
                        "id": "a103a161-0326-4075-b1f6-588a6460a8fa",
                        "title": "",
                        "type": "Composite",
                        "config": {
                            "operator": "LessThan",
                            "combine_on": "exact_match",
                            "left": {
                                "id": "08a1b601-ecc2-4b56-bc7e-c91c9c30743a",
                                "title": "New Data",
                                "type": "Single",
                                "config": {
                                    "type_id": "analytics_trade_summary",
                                    "market_id": 133,
                                    "interval": "hour",
                                    "lead": "1",
                                    "type": "vwap",
                                    "period": "month",
                                    "start_date": "2025-01-02",
                                    "end_date": "2025-09-11"
                                }
                            },
                            "right": {
                                "id": "a061e31e-9905-4d29-9132-b9c358f13ccc",
                                "title": "",
                                "type": "Formatter",
                                "config": {
                                    "type_id": "rolling_mean",
                                    "window": "50",
                                    "child": {
                                        "id": "981bd03d-dfe7-48f2-8e83-798d04263c05",
                                        "title": "New Data",
                                        "type": "Single",
                                        "config": {
                                            "type_id": "analytics_trade_summary",
                                            "market_id": 133,
                                            "interval": "hour",
                                            "lead": "1",
                                            "type": "vwap",
                                            "period": "month",
                                            "start_date": "2025-01-02",
                                            "end_date": "2025-09-11"
                                        }
                                    },
                                    "start_date": "2025-01-02",
                                    "end_date": "2025-09-11"
                                }
                            }
                        }
                    },
                    "right": {
                        "id": "ceb64576-2b4c-4007-bb67-e89556d2c73d",
                        "title": "",
                        "type": "Composite",
                        "config": {
                            "operator": "GreaterThan",
                            "combine_on": "exact_match",
                            "left": {
                                "id": "f76dba1c-5067-46af-b161-1b9abf563ae9",
                                "title": "New Data",
                                "type": "Single",
                                "config": {
                                    "type_id": "analytics_trade_summary",
                                    "market_id": 133,
                                    "interval": "hour",
                                    "lead": "1",
                                    "type": "vwap",
                                    "period": "month",
                                    "start_date": "2025-01-02",
                                    "end_date": "2025-09-11"
                                }
                            },
                            "right": {
                                "id": "8a562f13-05bd-4342-9521-0a79f4a7d9d5",
                                "title": "",
                                "type": "Formatter",
                                "config": {
                                    "type_id": "rolling_mean",
                                    "window": "10",
                                    "child": {
                                        "id": "8ba5ad9d-7f7e-44c8-b8bc-96740c595d4c",
                                        "title": "New Data",
                                        "type": "Single",
                                        "config": {
                                            "type_id": "analytics_trade_summary",
                                            "market_id": 133,
                                            "interval": "hour",
                                            "lead": "1",
                                            "type": "vwap",
                                            "period": "month",
                                            "start_date": "2025-01-02",
                                            "end_date": "2025-09-11"
                                        }
                                    },
                                    "start_date": "2025-01-02",
                                    "end_date": "2025-09-11"
                                }
                            }
                        }
                    }
                }
            },
            "right": {
                "id": "7ce55c1d-81ca-4959-8e9c-5504d777b59f",
                "title": "Moved to next hour",
                "type": "Formatter",
                "config": {
                    "type_id": "offset",
                    "value": "1",
                    "type": "hour",
                    "child": {
                        "id": "62fed594-0bff-461f-942a-9aef531bb317",
                        "title": "Below both",
                        "type": "Composite",
                        "config": {
                            "operator": "Filter",
                            "combine_on": "exact_match",
                            "left": {
                                "id": "7b9253ae-247b-4e75-8a04-88604f7359f3",
                                "title": "",
                                "type": "Composite",
                                "config": {
                                    "operator": "LessThan",
                                    "combine_on": "exact_match",
                                    "left": {
                                        "id": "b7581b01-c631-44ae-ae11-513bf80cda19",
                                        "title": "New Data",
                                        "type": "Single",
                                        "config": {
                                            "type_id": "analytics_trade_summary",
                                            "market_id": 133,
                                            "interval": "hour",
                                            "lead": "1",
                                            "type": "vwap",
                                            "period": "month",
                                            "start_date": "2025-01-02",
                                            "end_date": "2025-09-11"
                                        }
                                    },
                                    "right": {
                                        "id": "c9609539-d20a-4d39-a4e6-b7f1e1c4484e",
                                        "title": "",
                                        "type": "Formatter",
                                        "config": {
                                            "type_id": "rolling_mean",
                                            "window": "50",
                                            "child": {
                                                "id": "416152e1-d673-4f6a-8598-8de40e9f746a",
                                                "title": "New Data",
                                                "type": "Single",
                                                "config": {
                                                    "type_id": "analytics_trade_summary",
                                                    "market_id": 133,
                                                    "interval": "hour",
                                                    "lead": "1",
                                                    "type": "vwap",
                                                    "period": "month",
                                                    "start_date": "2025-01-02",
                                                    "end_date": "2025-09-11"
                                                }
                                            },
                                            "start_date": "2025-01-02",
                                            "end_date": "2025-09-11"
                                        }
                                    }
                                }
                            },
                            "right": {
                                "id": "28e2c97c-64d0-423e-a284-8c5c680bb7da",
                                "title": "",
                                "type": "Composite",
                                "config": {
                                    "operator": "LessThan",
                                    "combine_on": "exact_match",
                                    "left": {
                                        "id": "82ce2445-a9d9-4435-8aea-39aa29d6d634",
                                        "title": "New Data",
                                        "type": "Single",
                                        "config": {
                                            "type_id": "analytics_trade_summary",
                                            "market_id": 133,
                                            "interval": "hour",
                                            "lead": "1",
                                            "type": "vwap",
                                            "period": "month",
                                            "start_date": "2025-01-02",
                                            "end_date": "2025-09-11"
                                        }
                                    },
                                    "right": {
                                        "id": "1a48b82b-afea-4311-95a5-aa30ca311156",
                                        "title": "",
                                        "type": "Formatter",
                                        "config": {
                                            "type_id": "rolling_mean",
                                            "window": "10",
                                            "child": {
                                                "id": "45d2deb4-8f70-4970-9953-2875d13381f0",
                                                "title": "New Data",
                                                "type": "Single",
                                                "config": {
                                                    "type_id": "analytics_trade_summary",
                                                    "market_id": 133,
                                                    "interval": "hour",
                                                    "lead": "1",
                                                    "type": "vwap",
                                                    "period": "month",
                                                    "start_date": "2025-01-02",
                                                    "end_date": "2025-09-11"
                                                }
                                            },
                                            "start_date": "2025-01-02",
                                            "end_date": "2025-09-11"
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "start_date": "2025-01-02",
                    "end_date": "2025-09-11"
                }
            }
        }
    }
}